import PropTypes from 'prop-types';
import { useEffect, useCallback, useState } from 'react';
import { paths } from 'src/routes/paths';
import { useRouter } from 'src/routes/hooks';
import { useAuthContext } from '../hooks';

const loginPaths = {
  jwt: paths.auth.jwt.clinic_login,
};

export default function ClinicAuthGuard({ children, allowedClinicId }) {
  const router = useRouter();
  const { authenticated, user, method } = useAuthContext();
  const [checked, setChecked] = useState(false);

  const check = useCallback(() => {
    if (!authenticated) {
      const searchParams = new URLSearchParams({ returnTo: window.location.pathname }).toString();
      const loginPath = loginPaths[method];
      router.replace(`${loginPath}?${searchParams}`);
    } else if (allowedClinicId && user?.clinic_id !== allowedClinicId) {
      alert('User access denied');
      router.replace(paths.clinic_dashboard.root);
    } else {
      setChecked(true);
    }
  }, [authenticated, user, allowedClinicId, method, router]);

  useEffect(() => {
    check();
  }, [check]);

  if (!checked) return null;

  return <>{children}</>;
}

ClinicAuthGuard.propTypes = {
  children: PropTypes.node,
  allowedClinicId: PropTypes.string,
};
